import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=c52a14e8&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52a14e8')) {
      api.createRecord('c52a14e8', component.options)
    } else {
      api.reload('c52a14e8', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=c52a14e8&", function () {
      api.rerender('c52a14e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2clHv9Pe0YCnE/JS/cancellationPolicy.vue"
export default component.exports